import React, { useRef, useState } from 'react';
import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import emailjs from '@emailjs/browser';
import { Footer } from '../../../../containers';
import { Navbar } from '../../../../components';
import './Oi-Ekdoloseis-Mas.css';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../../../assets/OEFE.jpg';
import labora from '../../../../assets/labora.jpg';
import edu4schools from '../../../../assets/edu4schools.png';
import ypourgeio from '../../../../assets/ypourgeio.jpg';
import Video1 from './Photo/AponomiEnthimiwn2024.mp4';
import Video2 from './Photo/Vasilopita2023.mp4';
import Video3 from './Photo/Vasilopita2024.mp4';
import Video4 from './Photo/Labora2023.mp4';
import Video5 from './Photo/AponomiEnthimiwn2023.mp4';
import image1 from './Photo/image1.jpg';
import image2 from './Photo/image2.jpg';
import image3 from './Photo/image3.jpg';

const images = [
  { src: image1 },
  { src: image2 },
  { src: image3 },
];

const Ekdoloseis = () => {

    const form = useRef();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
            .then((result) => {
                console.log(result.text);
                console.log("message sent");
                e.target.reset();
                setShowSuccess(true);
                setShowError(false);
            }, (error) => {
                console.log(error.text);
                setShowSuccess(false);
                setShowError(true);
            });
    };

    const closePopup = () => {
        setShowSuccess(false);
        setShowError(false);
    };

    return (
        <div className="Oi-Ekdoloseis-Mas">
            <div className="gradient__bg">
                <Navbar />
            </div>
            <div className="Oi-Ekdoloseis-Mas__main-container">
                <div className="Oi-Ekdoloseis-Mas__container">
                    <div className="Oi-Ekdoloseis-Mas__container-h">
                        <h1>Οι Εκδηλώσεις μας</h1>
                        <div className="Oi-Ekdoloseis-Mas__container-p">
                            <p>Ο μαθητής της Α’ Λυκείου παρακολουθεί μαθήματα για μια ολοκληρωμένη κάλυψη γενικών γνώσεων και του δίνεται η δυνατότητα, με την βοήθεια επαγγελματικού προσανατολισμού να επιλέξει από τόσο νωρίς, την κατάλληλη ομάδα προσανατολισμού που καλείται να ακολουθήσει στην Β’ Λυκείου.</p>
                        </div>
                        <div className="gallery-container">
                            <div className="gallery-text">
                                <h2>Απονομή Ενθυμίων 2024</h2>
                            </div>
                            <div className="gallery-item" onClick={() => setOpen(true)}>
                                <img src={image1} alt="Gallery 1" style={{ cursor: 'pointer' }} />
                                <div className="gallery-caption">x10</div>
                            </div>
                            <div className="gallery-item">
                                <video muted loop controls>
                                    <source src={Video1} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        <div className="gallery-container">
                            <div className="gallery-text">
                                <h2>Βασιλόπιτα 2023</h2>
                            </div>
                            <div className="gallery-item" onClick={() => setOpen(true)}>
                                <img src={image1} alt="Gallery 1" style={{ cursor: 'pointer' }} />
                                <div className="gallery-caption">x10</div>
                            </div>
                            <div className="gallery-item">
                                <video muted loop controls>
                                    <source src={Video2} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        <div className="gallery-container">
                            <div className="gallery-text">
                                <h2>Βασιλόπιτα 2024</h2>
                            </div>
                            <div className="gallery-item" onClick={() => setOpen(true)}>
                                <img src={image1} alt="Gallery 1" style={{ cursor: 'pointer' }} />
                                <div className="gallery-caption">x10</div>
                            </div>
                            <div className="gallery-item">
                                <video muted loop controls>
                                    <source src={Video3} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        <div className="gallery-container">
                            <div className="gallery-text">
                                <h2>Labora 2023</h2>
                            </div>
                            <div className="gallery-item" onClick={() => setOpen(true)}>
                                <img src={image1} alt="Gallery 1" style={{ cursor: 'pointer' }} />
                                <div className="gallery-caption">x10</div>
                            </div>
                            <div className="gallery-item">
                                <video muted loop controls>
                                    <source src={Video4} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        <div className="gallery-container">
                            <div className="gallery-text">
                                <h2>Απονομή Ενθυμίων 2024</h2>
                            </div>
                            <div className="gallery-item" onClick={() => setOpen(true)}>
                                <img src={image1} alt="Gallery 1" style={{ cursor: 'pointer' }} />
                                <div className="gallery-caption">x10</div>
                            </div>
                            <div className="gallery-item">
                                <video muted loop controls>
                                    <source src={Video5} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Oi-Ekdoloseis-Mas__side-Containers">
                    <div className="Oi-Ekdoloseis-Mas__side-Container1">
                        <h1>Χρήσιμες Σελίδες</h1>
                        <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                            <AccordionItem uuid="a">
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Σημεία Υπεροχής
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <p>
                                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                                    </p>
                                    <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                                        <button className="custom-btn btn-5">Λεπτομέρειες</button>
                                    </a>
                                </AccordionItemPanel>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        "Ομάδα ή Μονάδα" ;
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <p>
                                        Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO-
                                    </p>
                                    <a href="/OmadaMonada" target="_blank" rel="noopener noreferrer">
                                        <button className="custom-btn btn-5">Λεπτομέρειες</button>
                                    </a>
                                </AccordionItemPanel>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <p>
                                        Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                                    </p>
                                    <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                                        <button className="custom-btn btn-5">Λεπτομέρειες</button>
                                    </a>
                                </AccordionItemPanel>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Σχόλια Μαθητών
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <p>
                                        Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας .
                                    </p>
                                    <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                                        <button className="custom-btn btn-5">Λεπτομέρειες</button>
                                    </a>
                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion>
                    </div>
                    <div className="anodos__oi-ekdoloseis-mas-email-container">
                        <form className="anodos__oi-ekdoloseis-mas-email-container_form" ref={form} onSubmit={sendEmail}>
                            <h1 className="anodos__oi-ekdoloseis-mas-email-container_h1">Φόρμα Επικοινωνίας</h1>
                            <label className="anodos__oi-ekdoloseis-mas-email-container_label">Όνομα</label>
                            <input className="anodos__oi-ekdoloseis-mas-email-container_input" type="text" name="user_name" required/>
                            <label className="anodos__oi-ekdoloseis-mas-email-container_label">Email</label>
                            <input className="anodos__oi-ekdoloseis-mas-email-container_input" type="email" name="user_email" required/>
                            <label className="anodos__oi-ekdoloseis-mas-email-container_label">Μήνυμα</label>
                            <textarea className="anodos__oi-ekdoloseis-mas-email-container_input-message" name="message" required/>
                            <input className="anodos__oi-ekdoloseis-mas-email-container_btn" type="submit" value="Αποστολή" />
                        </form>

                        {showSuccess && (
                            <div className="anodos__oi-ekdoloseis-mas-email-container_popup anodos__oi-ekdoloseis-mas-email-container_popup--success">
                                <span>Your message was sent successfully!</span>
                                <button className="anodos__oi-ekdoloseis-mas-email-container_close" onClick={closePopup}>X</button>
                            </div>
                        )}

                        {showError && (
                            <div className="anodos__oi-ekdoloseis-mas-email-container_popup anodos__oi-ekdoloseis-mas-email-container_popup--error">
                                <span>There was an error sending your message. Please try again later.</span>
                                <button className="anodos__oi-ekdoloseis-mas-email-container_close" onClick={closePopup}>X</button>
                            </div>
                        )}
                    </div>
                    <div className="anodos__Oi-Ekdoloseis-Mas-links-container">
                        <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                            <div className="anodos__Oi-Ekdoloseis-Mas-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                        </a>
                        <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                            <div className="anodos__Oi-Ekdoloseis-Mas-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                        </a>
                        <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                            <div className="anodos__Oi-Ekdoloseis-Mas-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                        </a>
                        <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                            <div className="anodos__Oi-Ekdoloseis-Mas-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                        </a>
                    </div>
                </div>
            </div>
            {open && (
              <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={images}
                index={index}
              />
            )}
            <Footer />
        </div>
    )
}

export default Ekdoloseis